export const DepartmentList = [
  {
    department: "Community Health & Outreach",
    designations: [
      "Awareness & Education Officers",
      "Dieticians",
      "Field Health Officers",
      "Health Camp Coordinators",
      "Nutrition Officers",
      "Program Director",
    ],
  },
  {
    department: "Customer Care & Support",
    designations: [
      "Customer Service Manager",
      "Health Program Advisors",
      "Wellness Support Executives",
    ],
  },
  {
    department: "Education & Training Department",
    designations: [
      "Assessment & Evaluation Officer",
      "Curriculum Development Officer",
      "E-Learning / Digital Education Manager",
      "Health Educators",
      "Internship & Placement Officer",
      "Nutrition & Wellness Trainers",
      "Principal Director",
      "Research & Content Writers",
      "Training & Certification Coordinator",
    ],
  },
  {
    department: "Executive & Management",
    designations: [
      "Mission Director / Managing Director (MD)",
      "Support Officer (SO)",
    ],
  },
  {
    department: "Finance & Accounts",
    designations: [
      "Accountant",
      "Accounts Manager",
      "Billing & Audit Officer",
      "Chief Financial Officer (CFO)",
    ],
  },
  {
    department: "Business Development",
    designations: [
    "ZWO (Zonal Wellness Officer)",
    "RWO (Regional Wellness Officer)",
    "Senior DWO (District Wellness Officer)",
    "Junior DWO (District Wellness Officer)",
    "AWO (Area Wellness Officer)",          
    ],
  },
  {
    department: "Human Resources & Employee Management",
    designations: [
      "CHRWO (Chief HR Wellness Officer)",
      "HR Executive",
      "HR Wellness Officer (HRWO)",
      "Payroll & Compliance Officer",
      "Recruitment Officer",
      "Training & Development Coordinator",
    ],
  },
  {
    department: "Techinical Department",
    designations: [
      "CTO (Chief Technical Officer)",
      "Chief ITWO",
      "Backend Web/App Developer",
      "Data Analyst",
      "Frontend Web/App Developer",
      "IT Wellness Officer (ITWO)",
      "Technical Support",
    ],
  },
  {
    department: "Laboratory & Diagnostics",
    designations: [
      "Lab Director",
      "Lab Technicians",
      "Pathologists",
      "Sample Collection Officers",
    ],
  },
  {
    department: "Marketing & Communications",
    designations: [
      "Community Outreach Coordinator",
      "Marketing Manager",
      "PR & Branding Officer",
      "Social Media Lead",
    ],
  },
  {
    department: "Medical Services Department",
    designations: [
      "Cardiologists",
      "Chief Medical Officer (CMO)",
      "Clinical Psychologists",
      "Community Medicine Experts",
      "Dentists",
      "Dermatologists",
      "Endocrinologists",
      "ENT Specialists",
      "Family Medicine Specialists",
      "Fertility & Reproductive Specialists",
      "Gastroenterologists",
      "General Physicians (MBBS/MD)",
      "Gynecologists / Obstetricians",
      "Immunologists",
      "Nephrologists",
      "Oncologists",
      "Ophthalmologists",
      "Orthopedic",
      "Panelist Doctor",
      "Pathologists",
      "Pediatricians",
      "Physiotherapists",
      "Psychiatrists",
      "Radiologists",
      "Senior Specialist",
      "Sports Medicine Doctors",
      "Trichologists",
      "Wellness Counselors",
    ],
  },
  {
    department: "Recruitment Department",
    designations: [
      "Advertising & Employer Branding Officer",
      "Assessment & Evaluation Officer",
      "Exam Administration Executives",
      "Exam Controller",
      "Examination & Assessment Officer",
      "Examination Director / Head of Examinations",
      "Invigilators / Proctors",
      "Onboarding & Induction Officer",
      "Online Examination Officer",
      "Question Bank & Content Specialist",
      "Recruitment Director",
      "Recruitment Executives / Assistants",
      "Recruitment Manager",
      "Results & Certification Officer",
      "Screening & Interview Coordinator",
    ],
  },
  {
    department: "Research & Development (R&D)",
    designations: [
      "Clinical Researchers",
      "Data & Health Analysts",
      "Product Development Specialists",
      "Research Head",
    ],
  },
  {
    department: "Supplementation & Product Department",
    designations: [
      "Distribution & Logistics Coordinator",
      "Inventory Manager",
      "Procurement Officer",
      "Product Head (Supplements/Wellness Products)",
    ],
  },
  {
    department: "Support & Admin Departments",
    designations: [
      "Administration Manager",
      "Facility & Safety Officer",
      "Legal & Compliance Officer",
      "Office Executive",
    ],
  },
];
